import React, { Component } from 'react';
import $ from "jquery";
class OurTeamInfo extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

  componentDidMount() {

  }

  toggle_info(id){
    if($("#"+id).hasClass("hide")){
      $("#"+id+"_i").text("Read Less...");
    }else {
      $("#"+id+"_i").text("Read More...")
    }
    $('#'+id).toggleClass('hide');
  }



  render() {
    return (

       <div class="container-xxl py-5 inner_con_grey" id="leader">

             <div class="container inner_con mb-5">
                 <h1 class="text-start mb-2 wow fadeInUp" data-wow-delay="0.1s">Managing Partner</h1>
                 <section className="team-section">

               <div className="team-card long-text">
                 <div className="team-image">
                   <img src="/assets/img/profile/prem_cudhary.png" alt="Prem Choudhary "/>
                 </div>
                 <div className="team-content">
                   <h3>Prem C. Choudhary</h3>
                   <div className="team-role team_role_mb">Managing Partner, BYLAWS Legal LLP</div>
                   <p><i>[B Sc, LLB, LLM (Cyber Laws), MBA (Financial markets), CS]</i></p>
                   <p>
                   Prem C. Choudhary is the Managing Partner of BYLAWS Legal LLP, a
                   governance-centric law firm built on precision, regulatory depth and institutional
                   advisory standards. With over 18 years of experience across India’s financial
                   services, capital markets and regulated ecosystems, he has held senior legal and
                   compliance leadership positions within LGT India, Times Internet/ET Money, Kotak
                   Mahindra bank, Kotak Securities, Bombay Stock Exchange etc. leading wealth management groups, stock
                   broking institutions, depository participant entities, NBFC structures and
                   technology-driven financial platforms.
                   </p>

                   <div className="hide" id='prem_cudhary'>
                   <p>
                   His professional journey reflects extensive engagement with Bombay Stock
                   Exchnage, SEBI-regulated intermediaries, exchange frameworks, enforcement
                   environments and board-level governance architecture. His core expertise spans
                   regulatory licensing and structuring, capital markets law, financial sector governance,
                   enforcement response strategy, AML architecture and complex corporate advisory.
                   </p>

                   <p>
                   A Company Secretary (Professional), LL.M. in Cyber Laws, MBA (Finance) and law
                   graduate, he brings rare convergence of legal, compliance, secretarial and financial
                   literacy to high-impact advisory mandates.
                   </p>

                   <p>
                   Under his leadership, BYLAWS Legal LLP is positioning not merely as a law firm but
                   as a strategic governance partner for institutions, promoters and boards seeking
                   legally fortified growth. His vision is to build BYLAWS into a benchmark institution
                   recognised for disciplined advisory, structural integrity and uncompromising
                   professional standards.
                   </p>

                   </div>
                   <p className="read_on" onClick={this.toggle_info.bind(this,'prem_cudhary')}><i id="prem_cudhary_i">Read More...</i></p>
                 </div>
               </div>

               </section>
              </div>

              <div class="container inner_con mb-5">
                  <h1 class="text-start mb-2 wow fadeInUp" data-wow-delay="0.1s">Other Partners</h1>
                  <section className="team-section">

                  <div className="team-card reverse">
                    <div className="team-image">
                      <img src="/assets/img/profile/kalyani_pate.jpg" alt="Kalyani Prakash Pate"/>
                    </div>
                    <div className="team-content">
                      <h3>Kalyani Prakash Pate</h3>
                      <div className="team-role team_role_mb">Partner, BYLAWS Legal LLP</div>
                      <p><i>[LLB, Post graduate diploma in IPR]</i></p>
                      <p>
                      Kalyani Prakash Pate is a Partner at BYLAWS Legal LLP, with a practice centred on
                      Maharashtra local legislations, real estate advisory and socially driven legal
                      intervention. She leads the firm’s pro-bono and victim support initiatives, focusing on
                      providing structured legal assistance to individuals facing financial distress, property
                      disputes, domestic challenges and regulatory hardship. Her work is grounded in
                      ensuring access to justice through responsible legal representation, guidance on
                      rights awareness and procedural support before local authorities and forums across
                      Maharashtra.
                      </p>


                      <div className="hide" id='kalyani_pate'>
                      <p>
                      Kalyani actively works with vulnerable stakeholders, offering advisory and
                      documentation assistance in matters involving local governance bodies, housing
                      societies, municipal compliances and revenue authorities. She plays a key role in
                      supporting victims requiring structured legal recourse, ensuring matters are handled
                      with sensitivity, confidentiality and procedural discipline.
                      </p>

                      <p>
                      In addition to her pro-bono focus, she provides targeted business support to Micro,
                      Small and Medium Enterprises (MSMEs), assisting them with regulatory
                      registrations, local compliance structuring, contract documentation, real estate due
                      diligence and operational risk mitigation under Maharashtra-specific frameworks. Her
                      advisory integrates practical ground-level regulatory navigation with legally sound
                      documentation, enabling small businesses and first-generation entrepreneurs to
                      operate within compliant and sustainable structures.
                      </p>

                      <p>
                      Through her work, Kalyani strengthens BYLAWS Legal LLP’s commitment to socially
                      responsible legal practice while reinforcing the firm’s capability in grassroots
                      regulatory support and MSME-oriented advisory across Maharashtra.
                      </p>

                      </div>
                      <p className="read_on" onClick={this.toggle_info.bind(this,'kalyani_pate')}><i id="kalyani_pate_i">Read More...</i></p>
                    </div>
                  </div>

                </section>
               </div>

               <div class="container inner_con mb-5">
                   <h1 class="text-start mb-2 wow fadeInUp" data-wow-delay="0.1s">Counsels</h1>
                   <section className="team-section">

                   <div className="team-card">
                     <div className="team-image">
                       <img src="/assets/img/profile/devendra_bambardekar.png" alt="Devendra Bambardekar"/>
                     </div>
                     <div className="team-content">
                       <h3>Devendra Bambardekar</h3>
                       <div className="team-role team_role_mb">Banking and Fema Compliance Counsel</div>
                       <p><i>[BCom, Associate Chartered Accountant(ACA)]</i></p>
                       <p>
                       Devendra Bambardekar is a seasoned regulatory professional with nearly three decades of experience in the banking and financial services sector. He is a Chartered Accountant, a Certified Treasury Manager (ICFAI) and has completed a Management Development Program from IIM, Ahmedabad. He spent over 22 years with Kotak Mahindra Bank as a senior leader, overseeing multiple compliance and regulatory verticals, and has also been associated with IDBI Bank and Deloitte in the early stages of his career.
                       </p>


                       <div className="hide" id='devendra_bambardekar'>
                       <p>
                       He possesses deep domain expertise across FEMA, banking regulations, NBFC frameworks, treasury operations and capital markets advisory. His advisory practice focuses on complex regulatory matters, including cross-border transactions under FEMA such as FDI, ECB, overseas investments, NRI/OCI transactions, LRS and trade structures, alongside broader banking, NBFC and capital market regulatory frameworks.
                       </p>

                       <p>
                       He is associated with BYLAWS Legal in a senior advisory capacity, contributing to the firm’s regulatory and cross-border transaction capabilities. He brings strong institutional perspective, regulatory insight and execution-driven advisory to clients operating in highly regulated environments, particularly in matters involving FEMA structuring, banking and NBFC compliance and capital market regulations.
                       </p>

                       </div>
                       <p className="read_on" onClick={this.toggle_info.bind(this,'devendra_bambardekar')}><i id="devendra_bambardekar_i">Read More...</i></p>
                     </div>
                   </div>

                   <div className="team-card reverse">
                     <div className="team-image">
                       <img src="/assets/img/profile/arun_poojary.png" alt="Arun Poojary"/>
                     </div>
                     <div className="team-content">
                       <h3>Arun Poojary</h3>
                       <div className="team-role team_role_mb">Vice president – Capital Market Regulatory Advisory</div>
                       <p><i>[B.Com, LLB, DBM]</i></p>
                       <p>
                       Arun Kumar Poojary is Vice president – Capital Market Regulatory Advisory at BYLAWS Legal LLP, strengthening the
                       firm’s Capital Markets and Financial Regulatory Advisory practice with nearly two
                       decades of specialised experience in Exchange and depository compliances, AML
                       governance and regulator-facing frameworks. His professional journey includes
                       mid-senior roles with reputed institutions such as ICICI Securities Limited, Kotak
                       Securities Limited and Multi Commodity Exchange of India Limited, where he was
                       actively involved in exchange-regulated environments and institutional compliance
                       architecture.
                       </p>
                       <div className="hide" id="arun_poojary">
                       <p>
                       During his tenure as Assistant Vice President at ICICI Securities and with Kotak
                       Securities, he led regulatory inspection management involving Securities and
                       Exchange Board of India, National Stock Exchange of India and Bombay Stock
                       Exchange, CDSL, handling inspection observations, regulatory circular
                       implementation, enforcement responses and enterprise-level AML oversight. His
                       experience includes surveillance alert monitoring, suspicious transaction analysis
                       under the Prevention of Money Laundering Act, 2002, STR reporting frameworks,
                       depository participant compliance and capital adequacy supervision within
                       broker-dealer structures.
                       </p>

                       <p>
                       Arun’s core strengths lie in AML governance systems, regulatory response strategy,
                       exchange compliance implementation, surveillance and market abuse monitoring,
                       and institution-level compliance documentation structuring. He holds degrees in
                       Commerce and Law, a Diploma in Business Management, AML/KYC certification
                       from IIBF and NISM Series VII – Securities Operations & Risk Management
                       certification, reflecting a strong blend of legal, operational and risk management
                       capability.
                       </p>

                       <p>
                       Through his association with BYLAWS Legal LLP, Arun enhances the firm’s capacity
                       to advise intermediaries, brokers, depository participants and financial institutions on
                       regulator-ready compliance frameworks, inspection preparedness and risk-calibrated
                       capital markets governance, delivered in alignment with statutory standards and
                       institutional best practices.
                       </p>

                       </div>
                       <p className="read_on" onClick={this.toggle_info.bind(this,'arun_poojary')}><i id="arun_poojary_i">Read More...</i></p>
                     </div>
                   </div>

                  <div className="team-card">
                    <div className="team-image">
                      <img src="/assets/img/profile/rajesh_thakur.png" alt="Rajesh Thakur"/>
                    </div>
                    <div className="team-content">
                      <h3>Rajesh Thakur</h3>
                      <div className="team-role team_role_mb">Advocate – Real estate and Land laws</div>
                      <p><i>[LLB, LLM (Business Law)]</i></p>
                      <p>
                      Rajesh Thakur is an Advocate, bringing over 25 years of comprehensive
                      professional experience in the real estate sector, including more than eight years of
                      focused courtroom practice in property and civil litigation. His career uniquely
                      combines hands-on real estate development exposure with structured legal
                      advocacy, enabling him to approach complex land and project disputes with both
                      commercial depth and procedural rigour. This dual perspective positions him to
                      advise not merely on legal issues in abstraction, but on the practical realities of
                      documentation, regulatory approvals, project execution risks and dispute escalation.
                      </p>

                      <div className="hide" id="rajesh_thakur">
                      <p>
                      Holding a Bachelor’s degree, Bachelor of Laws and a Master of Laws (LL.M.) in
                      Business Law, Rajesh has developed a litigation practice concentrated in Property
                      and Land Laws, Real Estate Disputes, Labour and Employment Laws and Civil
                      Proceedings. He regularly represents clients in matters involving title and ownership
                      conflicts, development and joint venture disputes, conveyancing and documentation
                      challenges, land acquisition complexities, project-related contractual conflicts and
                      ancillary civil remedies before appropriate judicial and quasi-judicial forums.
                      </p>

                      <p>
                      He holds extensive sectoral involvement, including participation in the development
                      of resort and farm projects, and granular understanding of land due diligence,
                      regulatory interfaces, documentation structuring and compliance navigation. Through
                      his association with BYLAWS Legal LLP, he reinforces the firm’s dispute resolution
                      strength in high-value land and property matters, delivering legally robust,
                      commercially aware and strategically calibrated representation in accordance with
                      the highest professional standards.
                      </p>

                      </div>
                      <p className="read_on" onClick={this.toggle_info.bind(this,'rajesh_thakur')}><i id="rajesh_thakur_i">Read More...</i></p>
                    </div>
                  </div>

                  <div className="team-card reverse">
                    <div className="team-image">
                      <img src="/assets/img/profile/kishor_kamble.png" alt="Kishor Kamble"/>
                    </div>
                    <div className="team-content">
                      <h3>Kishor Kamble</h3>
                      <div className="team-role team_role_mb">Advocate – Bombay High Court</div>
                      <p><i>[MSc., LL.B | Certified – UN Programs (Global Diplomacy, International Criminal Law, Social Change)]</i></p>
                      <p>
                      Kishor Kamble is a seasoned advocate with over four decades of experience, specialising in civil and commercial litigation, property and real estate disputes, corporate recovery, cooperative society matters and criminal law. His practice is strengthened by prior senior corporate experience, including his role as Deputy General Manager and Chief Geologist at ONGC, enabling him to bring a commercially informed and structurally grounded perspective to complex legal matters.
                      </p>
                      <div className="hide" id="kishor_kamble">
                      <p>
                      He regularly represents clients before courts and tribunals across Mumbai and Maharashtra, handling property disputes, recovery proceedings, consumer matters and criminal cases. His work involves handling complex property disputes, recovery proceedings, consumer claims, criminal matters and regulatory issues.
                      </p>
                      <p>
                      At BYLAWS Legal LLP, he is part of the firm’s litigation and dispute resolution practice, contributing to mandates across real estate, corporate disputes and criminal / white-collar matters.He plays a critical role in shaping dispute strategy, managing end-to-end litigation execution and supporting clients across both preventive advisory and high-stakes contentious engagements.
                      </p>
                      </div>
                      <p className="read_on" onClick={this.toggle_info.bind(this,'kishor_kamble')}><i id="kishor_kamble">Read More...</i></p>
                    </div>
                  </div>

                  <div className="team-card">
                    <div className="team-image">
                      <img src="/assets/img/profile/hetal_pandya.png" alt="Hetal Pandya"/>
                    </div>
                    <div className="team-content">
                      <h3>Hetal Pandya</h3>
                      <div className="team-role team_role_mb">Corporate, Transactions & Regulatory Advisory</div>
                      <p><i>[BCOM, LL.M., ACS]</i></p>
                      <p>
                      Hetal Pandya is an Advocate and CS with over 16 years of experience across corporate legal, secretarial, compliance and transaction advisory, with a strong focus on the BFSI and investment ecosystem.
                      </p>
                      <div className="hide" id="hetal_pandya">
                      <p>
                      Her practice covers venture capital, private equity, mergers and acquisitions, AIFs, fund and corporate structuring, legal due diligence, transaction documentation and regulatory advisory under the SEBI, RBI, FEMA and Companies Act frameworks. She has advised on the full investment lifecycle, including fund formation, fundraising, structuring, negotiations, regulatory compliances and exits.
                      </p>
                      <p>
                      At BYLAWS Legal LLP, Hetal strengthens the Firm’s corporate and transaction advisory capabilities, particularly in investment transactions, fund structuring, governance, regulatory compliance and complex commercial documentation. Her approach combines legal precision with practical and commercially workable solutions.
                      </p>
                      </div>
                      <p className="read_on" onClick={this.toggle_info.bind(this,'hetal_pandya')}><i id="hetal_pandya_i">Read More...</i></p>
                    </div>
                  </div>

                   <div className="team-card reverse">
                     <div className="team-image">
                       <img src="/assets/img/profile/pradeep_yadav.png" alt="Pradeep Yadav"/>
                     </div>
                     <div className="team-content">
                       <h3>Pradeep Yadav</h3>
                       <div className="team-role team_role_mb">Advocate</div>
                       <p><i>[LLB, DBS]</i></p>
                       <p>
                       Pradeep Yadav is a seasoned legal professional with over 16+ years of experience, specialising in real estate advisory, commercial disputes, consumer litigation and criminal law. He advises across the entire lifecycle of real estate transactions, ensuring compliance with applicable legal and regulatory frameworks. He also advises and represents clients before courts in a broad spectrum of criminal and white-collar matters, including bail, quashing and trial proceedings.
                       </p>
                       <div className="hide" id="pradeep_yadav">
                       <p>
                       He regularly represents clients before RERA authorities, consumer forums and courts across Delhi–NCR, handling builder–buyer disputes, possession and refund claims, deficiency of service matters and complex recovery proceedings, including cheque dishonour cases. His approach is risk-focused and commercially aligned, with a strong emphasis on practical and enforceable outcomes.
                       </p>
                       <p>
                       At BYLAWS Legal LLP, he is part of the firm’s litigation and dispute resolution practice, contributing to Delhi–NCR focused real estate advisory, criminal /white collar cases and enforcement mandates. He plays a key role in driving dispute strategy, managing end-to-end litigation execution and supporting clients across both preventive advisory and high-stakes contentious matters.
                       </p>
                       </div>
                       <p className="read_on" onClick={this.toggle_info.bind(this,'pradeep_yadav')}><i id="pradeep_yadav_i">Read More...</i></p>
                     </div>
                   </div>

                   <div className="team-card">
                     <div className="team-image">
                       <img src="/assets/img/profile/sonam_more.png" alt="Sonam More"/>
                     </div>
                     <div className="team-content">
                       <h3>Sonam More</h3>
                       <div className="team-role team_role_mb">Litigation, Real Estate & Dispute Resolution</div>
                       <p><i>[Advocate, B.L.S., LL.B., CS Foundation]</i></p>
                       <p>
                       Sonam More is an Advocate with over 11 years of professional legal experience across litigation, dispute resolution, real estate, corporate and commercial matters, contracts and legal advisory.
                       </p>
                       <div className="hide" id="sonam_more">
                       <p>
                       Her practice covers civil and commercial litigation, arbitration and mediation, recovery and negotiable instrument matters, RERA and property disputes, land acquisition matters, real estate documentation, commercial agreements, corporate advisory and contract drafting and negotiation. She has experience in representing clients before courts, tribunals and other judicial and quasi-judicial forums.
                       </p>
                       <p>
                       At BYLAWS Legal LLP, Sonam focuses on litigation, real estate and dispute-resolution matters, combining strategic case assessment, meticulous drafting and practical legal advice to protect client interests and achieve commercially workable outcomes.
                       </p>
                       </div>
                       <p className="read_on" onClick={this.toggle_info.bind(this,'sonam_more')}><i id="sonam_more_i">Read More...</i></p>
                     </div>
                   </div>

                   <div className="team-card reverse">
                     <div className="team-image">
                       <img src="/assets/img/profile/sanjeeta_nage.png" alt="Sanjeeta Nage"/>
                     </div>
                     <div className="team-content">
                       <h3>Sanjeeta Nage</h3>
                       <div className="team-role team_role_mb"></div>
                       <p><i>[LL.B]</i></p>
                       <p>
                       Sanjeeta Nage is a legal professional with focused exposure across corporate, regulatory and litigation-oriented assignments, complemented by a strong foundation in legal research and documentation support. A LL.B. from DY Patil University, she combines academic rigour with practical experience gained through structured internships across legal chambers, corporate legal environments and advisory setups.
                       </p>

                       <div className="hide" id="sanjeeta_nage">
                       <p>
                       Her experience spans drafting of legal notices, agreements and property related documentation, alongside hands-on exposure to RERA documentation, court filings etc. She has also developed familiarity with corporate documentation, compliance processes and statutory interpretation, enabling her to contribute effectively across both advisory and execution-driven mandates.
                       </p>
                       <p>
                       At BYLAWS Legal LLP, she contributes to the firm’s Corporate legal and Documentation Support functions, assisting in legal research, drafting and execution support across mandates.
                       </p>
                       </div>
                       <p className="read_on" onClick={this.toggle_info.bind(this,'sanjeeta_nage')}><i id="sanjeeta_nage_i">Read More...</i></p>
                     </div>
                   </div>



                   <div className="team-card">
                     <div className="team-image">
                       <img src="/assets/img/profile/aditi_bafna.png" alt="Aditi Bafna"/>
                     </div>
                     <div className="team-content">
                       <h3>Aditi Bafna</h3>
                       <div className="team-role team_role_mb">Advocate | Associate – Non-Litigation</div>
                       <p><i>[B.A. LL.B. (Hons.)]</i></p>
                       <p>
                       Aditi Bafna is a Legal Associate in the Non-Litigation practice at BYLAWS Legal LLP, Navi Mumbai, having joined the firm in October 2026. Her experience includes drafting, reviewing and negotiating commercial contracts, legal documentation, compliance support and legal research.
                       </p>

                       <div className="hide" id="aditi_bafna">
                       <p>
                       Before joining BYLAWS, she worked in documentation and compliance, handling commercial agreements with domestic and international clients, reviewing contractual obligations and legal risks, and coordinating execution of documents. She also has prior exposure to civil and family litigation, including research, preparation of pleadings and assistance with court procedures.
                       </p>
                       </div>
                       <p className="read_on" onClick={this.toggle_info.bind(this,'aditi_bafna')}><i id="aditi_bafna_i">Read More...</i></p>
                     </div>
                   </div>


                   <div className="team-card reverse">
                     <div className="team-image">
                       <img src="/assets/img/profile/siddesh_deshmukh.png" alt="Siddesh Deshmukh"/>
                     </div>
                     <div className="team-content">
                       <h3>Siddesh Deshmukh</h3>
                       <div className="team-role team_role_mb">Advocate | Associate – Litigation</div>
                       <p><i>[B.L.S., LL.B. | PG Diploma in Labour Laws]</i></p>
                       <p>
                       Siddesh Deshmukh is an Associate Advocate in the Litigation practice at BYLAWS Legal. His experience includes civil and criminal litigation, labour and employment laws, corporate and commercial matters and dispute resolution.
                       </p>

                       <div className="hide" id="siddesh_deshmukh">
                       <p>
                       Before joining BYLAWS, he worked with Advocate Santosh Mourya and D. P. Bhatt Associates, gaining practical experience in notices, agreements, pleadings, affidavits and other legal documents. He has also been involved in regular court proceedings and client coordination across civil, criminal, labour and commercial matters.
                       </p>
                       </div>
                       <p className="read_on" onClick={this.toggle_info.bind(this,'siddesh_deshmukh')}><i id="siddesh_deshmukh_i">Read More...</i></p>
                     </div>
                   </div>


                   <div className="team-card">
                     <div className="team-image">
                       <img src="/assets/img/profile/jenevee_dsilva.png" alt="Jenevee Dsilva"/>
                     </div>
                     <div className="team-content">
                       <h3>Jenevee Dsilva</h3>
                       <div className="team-role team_role_mb">Executive Assistant to Managing Partner | Administration Manager</div>
                       <p><i>[Bachelor of Business Administration (BBA)]</i></p>
                       <p>
                       Jenevee Dsilva serves as the Executive Assistant to the Managing Partner and Administration Manager at BYLAWS Legal LLP, Navi Mumbai. She has over five years of professional experience in office administration, client relationship management, executive coordination and operational support.
                       </p>

                       <div className="hide" id="jenevee_dsilva">
                       <p>
                       At BYLAWS, she is responsible for coordinating the Managing Partner’s office, overseeing day-to-day administrative operations and facilitating coordination with clients, professionals and internal teams.
                       </p>
                       <p>
                       Before joining BYLAWS, she worked with AMJ Ship Management Private Limited and Elite Marine Training & Solutions LLP, gaining experience in client servicing, recruitment coordination, employee onboarding, office administration and event management. She holds a Bachelor of Business Administration (BBA) from Annamalai University.
                       </p>
                       </div>
                       <p className="read_on" onClick={this.toggle_info.bind(this,'jenevee_dsilva')}><i id="jenevee_dsilva_i">Read More...</i></p>
                     </div>
                   </div>



                 </section>
                </div>



        </div>


    );
  }
}

export default OurTeamInfo;
